import { render, staticRenderFns } from "./TopicListRightMenuComponent.vue?vue&type=template&id=110e07b3&"
import script from "./TopicListRightMenuComponent.vue?vue&type=script&lang=js&"
export * from "./TopicListRightMenuComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports